module.exports = __webpack_public_path__ + "static/img/play-icon.5279f256.svg";